import { LocalHospital, Message, Reply, Textsms } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Inventory } from '../../../models/Inventory'
import { JobSimple } from '../../../models/JobSimple'
import { WidthProps } from '../../Layout/CommonStyle'
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined'
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined'
import InventoryReplyForm, {
  InventoryReplyFormValues,
} from '../../Popup/InventoryReplyForm'
import { useState } from 'react'
import Popup from '../../Popup/Popup'
import { User } from '../../../models/User'
import { axiosPost } from '../../Common/Axios'
import { useAppDispatch } from '../../../store'
import {
  removeFromInventories,
  setOutInventory,
} from '../../../store/mainSlice'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { unregisterInventory } from '../../Common/CommonApi'

type Props = {
  inventory: Inventory
  inventories: Inventory[]
  //setInventories: (inventories: Inventory[]) => void
  user: User
  imaegWidth?: number
  isShowRemoveInventory: boolean
}

function MenteeInventoryGrid(props: Props) {
  const [open, setOpen] = useState(false)
  const dispatch = useAppDispatch()

  const handleReplyClick = () => {
    console.log('reply clicked')
  }

  const onSubmitReply = async (values: InventoryReplyFormValues) => {
    console.log(values)
  }

  const handleRemoveFromInventory = async () => {
    if (
      !confirm(`${props.inventory.job.name}을 인벤토리에서 삭제하시겠습니까?`)
    ) {
      return
    }

    await unregisterInventory(
      props.inventory.job.id,
      props.inventory.userId,
      dispatch
    )
  }

  return (
    <Container imageWidth={props.imaegWidth}>
      {/* <Link to={'/job/' + props.inventory.job.id}> */}
      <Popup open={open} setOpen={setOpen} isTopCenter={false}>
        <InventoryReplyForm
          onSubmitReply={onSubmitReply}
          inventory={props.inventory}
          inventories={props.inventories}
          //setInventories={props.setInventories}
          user={props.user}
        />
      </Popup>

      <Image
        imageWidth={props.imaegWidth}
        onClick={() => setOpen(true)}
        src={props.inventory.job.photo}
      />

      {props.isShowRemoveInventory && (
        <RemoveIconButton onClick={() => handleRemoveFromInventory()}>
          <RemoveCircleOutlineIcon
            style={{
              backgroundColor: 'white',
              borderRadius: '50%',
            }}
          />
        </RemoveIconButton>
      )}

      {/* </Link> */}
      <ImageTool>
        <div>{props.inventory.job.name}</div>
        <div>
          <div>
            <IconButton onClick={() => setOpen(true)}>
              <CommentOutlinedIcon
                style={{ fontSize: '20px', marginRight: '5px' }}
                onClick={() => handleReplyClick()}
              />
            </IconButton>
            {props.inventory.replyCnt}
          </div>
          <div>
            <IconButton onClick={() => handleReplyClick()}>
              <ThumbUpOutlinedIcon
                style={{ fontSize: '20px', marginRight: '5px' }}
                onClick={() => handleReplyClick()}
              />
            </IconButton>
            {props.inventory.likeCnt}
          </div>
        </div>
      </ImageTool>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  width: ${(prop: WidthProps) =>
    prop.imageWidth ? prop.imageWidth + 'px' : '329px'};

  @media (max-width: 768px) {
    width: 100%;
  }
`

const Image = styled.img`
  width: ${(prop: WidthProps) =>
    prop.imageWidth ? prop.imageWidth + 'px' : '329px'};
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const ImageTool = styled.div`
  opacity: 0.8;
  font-size: 0.9rem;
  padding: 0;

  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }

  & > div:nth-child(1) {
    font-size: 1.1rem;
    font-weight: 600;
    text-align: center;
    /* border: 1px solid #ccc; */
    padding: 5px 0;
  }
  & > div:nth-child(2) {
    display: flex;
    justify-content: center;
    column-gap: 15px;
    padding-top: 5px;

    & > div {
      word-break: keep-all;
      word-wrap: normal;
      white-space: nowrap;
      text-align: right;
    }
  }

  button {
    padding: 0;
  }
`
const RemoveIconButton = styled(IconButton)`
  position: absolute !important;
  right: 0;
  top: 0;
  @media (max-width: 768px) {
    right: 10px;
  }
`

const Title = styled.div`
  padding-top: 33px;
  text-align: center;
`
export default MenteeInventoryGrid
